import React from "react";
import { useInternData } from "../../context/InternContext";
import api from "../../services/api";
import T from '../../assets/styles/theme';
import { resolveNotifRoute } from "../../utils/notifRouteResolver";
import "../../assets/styles/Intern/NotificationsPanel.css";

// InternDashboard passes onNav via the parent; but NotificationsPanel is rendered inside
// InternDashboard switch case directly. We accept optional onNavigate prop.
function NotificationsPanel({ onNavigate }) {
  const { notifications, refreshInternData } = useInternData();

  const handleMarkAllRead = async () => {
    try {
      await api.markAllNotificationsRead();
      if (refreshInternData) refreshInternData();
    } catch (e) { console.warn(e); }
  };

  const fmtTime = (t) => {
    if (!t) return '';
    try {
      const d = new Date(t);
      const diff = Math.floor((Date.now() - d) / 60000);
      if (diff < 1) return 'Just now';
      if (diff < 60) return `${diff}m ago`;
      if (diff < 1440) return `${Math.floor(diff / 60)}h ago`;
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
    } catch { return ''; }
  };

  const handleRead = async (n) => {
    if (!n?.id || (n.is_read && !n.unread)) return;
    try {
      await api.markNotificationRead(n.id);
      if (refreshInternData) refreshInternData();
    } catch (e) { console.warn(e); }
    // Navigate after marking read
    if (onNavigate) {
      const tab = resolveNotifRoute(n, 'intern');
      onNavigate(tab);
    }
  };

  const typeColor = {
    chat: '#0ea5e9', leave: '#f59e0b', helpdesk: '#ef4444',
    announcement: '#8b5cf6', announcements: '#8b5cf6',
    event: '#3b82f6', calendar: '#3b82f6', general: '#94a3b8',
  };
  const getColor = (n) => typeColor[(n.type||'').toLowerCase()] || '#6366f1';

  const items = (notifications || []).slice(0, 15);

  return (
    <div className="card animate-in delay-5">
      <div className="card-header">
        <div>
          <div className="card-title">Notifications</div>
          <div className="card-subtitle">Stay updated with important alerts</div>
        </div>
        <span onClick={handleMarkAllRead} className="notificationspanel-inline-1">Mark all read</span>
      </div>
      <div className="card-body">
        {items.length === 0 ? (
          <div style={{ '--notificationspanel-1-color': T.textMuted }} className="notificationspanel-dyn-1">
            No notifications yet
          </div>
        ) : items.map((n, idx) => {
          const isUnread = n.unread || !n.is_read;
          const color = getColor(n);
          return (
            <div
              className="notif-item notificationspanel-inline-2"
              key={n.id || idx}
              onClick={() => handleRead(n)}
              style={{ cursor: onNavigate ? 'pointer' : 'default' }}
            >
              <div className={`notif-dot ${isUnread ? 'unread' : 'read'}`}
                style={{ background: isUnread ? color : undefined }} />
              <div className="notificationspanel-inline-3">
                <div className={`notif-text ${isUnread ? '' : 'read'}`}>
                  {n.title || n.text || n.body || n.message || ''}
                </div>
                {n.body && n.title && (
                  <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 1 }}>{n.body}</div>
                )}
                <div className="notif-time">{fmtTime(n.time || n.created_at)}</div>
              </div>
              <div className={`notif-badge ${n.type || 'general'}`}>{n.type || 'info'}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default NotificationsPanel;
